import React from 'react';
import GoogleMapReact from 'google-map-react';
import { PropTypes } from 'prop-types';
import Config from '../../../config';

import { theme } from './theme';

import { Office } from 'modules/offices';
import ShowOnMapMarker from './ShowOnMapMarker';

const SimpleMap = ({ center, office }) => {
    return (
        <GoogleMapReact
            bootstrapURLKeys={{ key: Config.api.keys.googleMaps }}
            defaultCenter={center}
            defaultZoom={15}
            options={{
                styles: theme,
                disableDefaultUI: true,
            }}
            styles={theme}
        >
            <ShowOnMapMarker lat={center.lat} lng={center.lng} office={office} />
        </GoogleMapReact>
    );
};

SimpleMap.propTypes = {
    center: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number,
    }).isRequired,
    office: PropTypes.oneOf(Object.values(Office)).isRequired,
};

export default SimpleMap;
